module.exports = __webpack_public_path__ + "img/xroad_logo_64.5e4e9193.png";